import { css } from 'styled-components';
import { getTextColor } from '../../theme/defaultThemeOperators';
import { getFontWithFallback } from '../../utils/getFontWithFallback';
export const getBodyTypographyStyles = ({
  theme
}) => css(["font-family:", ";font-weight:400;font-size:14px;color:", ";line-height:24px;"], ({
  theme: {
    font: {
      fontFamily
    }
  }
}) => getFontWithFallback(fontFamily), getTextColor(theme));